import { getOpxHostAppName } from 'mini-opx-config/lib/getOpxHostAppName';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import type { MiniHostApps } from 'mini-opx-config/lib/types/MiniHostApps';

/**
 * Higher order function, that returns a getter to pick value based on the HostApp
 * @param valuesMap
 * @param defaultValue
 * @returns T
 */
export const createGetterForHostApp = <T = string>(
    valuesMap: Map<MiniHostApps, T>,
    defaultValue?: T
) => (): T => {
    // when in hosted-app scenario, like OutlookLite
    if (isHostAppFeatureEnabled('opxComponentLifecycle')) {
        const hostApp = getOpxHostAppName();

        const valueForHost = valuesMap.get(hostApp) || defaultValue;

        return valueForHost;
    }

    return defaultValue;
};
